import { CurvePointDTO } from "./curvePointDTO";

export interface dms {
  cardinal:string,
  degrees:number,
  minutes:number,
  seconds:number
}


export class CoordinatesModel {
  latitude : number;
  longitude : number;
  latLonDms : LatLonDMS = new LatLonDMS();
}

export class LatLonDMS {
  latitude:dms = {cardinal:"N", degrees: 0, minutes:0, seconds:0};
  longitude:dms = {cardinal:"W", degrees: 0, minutes:0, seconds:0};


  private toDegreesMinutesAndSeconds(coordinate:number, target:dms) {
    var absolute = Math.abs(coordinate);
    target.degrees = Math.floor(absolute);
    var minutesNotTruncated = (absolute - target.degrees) * 60;
    target.minutes = Math.floor(minutesNotTruncated);
    target.seconds = Math.floor((minutesNotTruncated - target.minutes) * 60);
  }

  private toDecimalDegrees(coordinate:dms){
    return (coordinate.degrees + coordinate.minutes/60 + coordinate.seconds/3600);
  }

  public fromLat(lat:number):void{
    this.toDegreesMinutesAndSeconds(lat, this.latitude);
    this.latitude.cardinal = ((lat > 0) ? "N" : "S");
  }
  public getStringFromLat(lat:number):string{
    this.fromLat(lat);
    return `${this.latitude.cardinal} ${this.latitude.degrees}º ${this.latitude.minutes}' ${this.latitude.seconds}''`
  }
  public toLat():number{
    let deg = this.toDecimalDegrees(this.latitude)

    if (this.latitude.cardinal == "S") {
        deg = deg * -1;
    } // Don't do anything for E
    return deg;
  }

  public fromLon(lon:number):void{
    this.toDegreesMinutesAndSeconds(lon, this.longitude);
    this.longitude.cardinal = ((lon > 0) ? "E" : "W");
  }
  public getStringFromLon(lon:number):string{
    this.fromLon(lon);
    return `${this.longitude.cardinal} ${this.longitude.degrees}º ${this.longitude.minutes}' ${this.longitude.seconds}''`
  }
  public toLon():number{

    let deg = this.toDecimalDegrees(this.longitude)

    if (this.longitude.cardinal == "W") {
        deg = deg * -1;
    } // Don't do anything for E
    return deg;
  }
}


export class ValidationCoordinatesDTO{
  coordinates: CurvePointDTO[] = [];
  flightLevel: number;
  projectId: number;
}
